<template>
  <v-container
    id="home-page"
    class="fill-height flex-column py-10 _ps-relative"
    :class="{ 'justify-center': !isActiveLineOfficialAccountEmpty }"
  >
    <modal-new-feature />
    <div class="d-flex flex-column justify-center _w-100pct px-10 px-md-0">
      <div class="_fs-36">
        สวัสดีครับ คุณ
        <span class="font-weight-bold _ps-relative _z-1">
          {{ userProfile.displayName }}
        </span>
      </div>

      <template v-if="!isActiveLineOfficialAccountEmpty">
        <div class="_fs-36">
          คุณกำลังใช้บริการ Basic ID
          <span class="primary--text font-weight-bold _ps-relative _z-1">
            {{ activeBasicId }}
          </span>
        </div>

        <v-row
          class="pt-8"
          align="stretch"
          style="z-index: 1;">
          <v-col
            cols="12"
            md="12">
            <v-card
              class="pa-5"
              style="height: 100%">
              <span class="font-weight-bold _fs-20">
                BROADCAST PACKAGE
              </span>
              <div class="pt-2 _fs-16">
                แพ็กเกจปัจจุบันของคุณ:
                <span class="primary--text font-weight-bold text-capitalize">
                  {{ activeLineOfficialAccount.packagePlan }}
                  <template v-if="activeLineOfficialAccount.packageMonth">
                    {{ activeLineOfficialAccount.packageMonth }}
                    เดือน
                  </template>
                </span>
                <span
                  v-if="activeLineOfficialAccount.packageExpiredAt"
                  class="error--text">
                  (หมดอายุ
                  {{ activeLineOfficialAccount.packageExpiredAt | dateTimeFormat }})
                  <v-btn
                    v-if="
                      isInRenewOrderDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER) &&
                        !hasNextPackagePlan
                    "
                    color="primary"
                    rounded
                    small
                    outlined
                    :to="{
                      name: 'OrderCreate',
                      params: { productType: 'package' },
                      query: { isRenew: true }
                    }"
                    @click="renewGTMEvent('existing_btn_renew_package_broadcast', 'click_buy_btn_renew_package_broadcast')"
                  >
                    ต่ออายุแพ็กเกจ
                  </v-btn>
                </span>

                <div
                  v-if="activeLineOfficialAccount.packageExpiredAt"
                  class="pt-2 _fs-16">
                  แพ็กเกจถัดไปของคุณของคุณ:
                  <span class="primary--text font-weight-bold text-capitalize">
                    {{ hasNextPackagePlan
                      ? activeLineOfficialAccount.nextPackagePlan + " " + activeLineOfficialAccount.nextPackageMonth + " เดือน"
                      : "Free" }}
                  </span>
                  <span v-if="activeLineOfficialAccount.nextPackageStartedAt != null">
                    (วันที่เริ่มใช้งาน
                    {{ activeLineOfficialAccount.nextPackageStartedAt | dateTimeFormat }}
                    -
                    {{ activeLineOfficialAccount.nextPackageExpiredAt | dateTimeFormat }})
                  </span>
                </div>

                <div v-if="activeLineOfficialAccount.packageExpiredAt">
                  จำนวนข้อความเพิ่มเติม {{ activeLineOfficialAccount.messageQty | numberComma }}
                  ข้อความ
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="12">
            <v-card
              class="pa-5"
              style="height: 100%">
              <span class="font-weight-bold _fs-20">
                PREMIUM ID
              </span>
              <div class="pt-2 _fs-16">
                แพ็กเกจปัจจุบันของคุณ:
                <span class="primary--text font-weight-bold">
                  {{ isFalsy(activeLineOfficialAccount.premiumId)
                    ? 'ไม่มี'
                    : activeLineOfficialAccount.premiumId }}
                </span>
                <span
                  v-if="!isFalsy(activeLineOfficialAccount.premiumId)"
                  class="error--text">
                  (หมดอายุ
                  <template v-if="!hasPremiumIdNext">
                    {{ activeLineOfficialAccount.premiumIdExpiredAt | dateTimeFormat }}
                  </template>
                  <template v-else>
                    {{ activeLineOfficialAccount.premiumIdNextExpiredAt | dateTimeFormat }}
                  </template>
                  )
                </span>
                <v-btn
                  v-if="
                    isInRenewPremiumIdDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)
                      && !isFalsy(activeLineOfficialAccount.premiumId)
                      && !hasPremiumIdNext
                  "
                  color="primary"
                  rounded
                  small
                  outlined
                  :to="{
                    name: 'OrderCreate',
                    params: { productType: 'premiumId' },
                    query: { isRenew: true }
                  }"
                  @click="renewGTMEvent('existing_btn_renew_premium', 'click_buy_btn_renew_premium')"
                >
                  ต่ออายุแพ็กเกจ
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="12">
            <v-card
              class="pa-5"
              style="height: 100%">
              <span class="font-weight-bold _fs-20">
                OA CHAT PACKAGE
              </span>
              <div class="pt-2 _fs-16">
                แพ็กเกจปัจจุบันของคุณ:
                <span class="primary--text font-weight-bold text-capitalize">
                  {{ activeLineOfficialAccount.oaChatMonth == null
                    ? 'Free'
                    : activeLineOfficialAccount.oaChatMonth + ' เดือน' }}
                </span>

                <span
                  v-if="activeLineOfficialAccount.oaChatExpiredAt"
                  class="pt-2 error--text">
                  (หมดอายุ
                  {{ activeLineOfficialAccount.oaChatExpiredAt | dateTimeFormat }})
                  <v-btn
                    v-if="
                      isInRenewOaChatDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER) &&
                        !hasNextOaChat
                    "
                    color="primary"
                    rounded
                    small
                    outlined
                    :to="{
                      name: 'OrderCreate',
                      params: { productType: 'oaChat' },
                      query: { isRenew: true }
                    }"
                    @click="renewGTMEvent('existing_btn_renew_oa', 'click_buy_btn_renew_oa')"
                  >
                    ต่ออายุแพ็กเกจ
                  </v-btn>
                </span>

                <div
                  v-if="activeLineOfficialAccount.oaChatExpiredAt != null"
                  class="pt-2 _fs-16">
                  แพ็กเกจถัดไปของคุณของคุณ:
                  <span class="primary--text font-weight-bold text-capitalize">
                    {{ hasNextOaChat
                      ? activeLineOfficialAccount.oaChatNextMonth + " เดือน"
                      : "Free" }}
                  </span>
                  <span v-if="hasNextOaChat">
                    (วันที่เริ่มใช้งาน
                    {{ activeLineOfficialAccount.oaChatNextStartedAt | dateTimeFormat }}
                    -
                    {{ activeLineOfficialAccount.oaChatNextExpiredAt | dateTimeFormat }})
                  </span>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </div>

    <div
      v-if="orders.length > 0"
      class="mt-12 _w-100pct _z-1">
      <div class="text-center _fs-36 _ps-relative">
        คุณมีออเดอร์สำหรับลูกค้าใหม่
      </div>

      <order-card-list
        class="mt-4"
        :orders="mapOrders">
      </order-card-list>
    </div>

    <div
      v-if="!isActiveLineOfficialAccountEmpty"
      class="mt-12 _w-100pct">
      <div class="text-center _fs-36 _ps-relative _z-1">
        กรุณาเลือกบริการที่ต้องการ
      </div>

      <v-row class="mt-4 _ps-relative">
        <img
          class="d-none d-md-block _space-banner _ps-absolute"
          src="/img/home/space-banner.jpg"
          loading="lazy"
          width="500"
          alt="Space Banner Image"
        />
        <v-col
          cols="10"
          offset="1"
          sm="8"
          offset-sm="2"
          offset-md="0"
          md="3">
          <v-card class="pa-10 text-center">
            <img
              src="/img/order/buy-package.png"
              height="85" />
            <div class="py-4 font-weight-bold _fs-24 _fs-lg-34 service-card-title">
              BROADCAST PACKAGE
            </div>
            <v-btn
              color="primary"
              width="100%"
              max-width="230px"
              rounded
              :to="{ name: 'OrderCreate', params: { productType: 'package' } }"
              @click="orderGTMEvent('existing_btn_package_broadcast_main', 'click_buy_btn_package_broadcast_main')"
            >
              สั่งซื้อ
            </v-btn>
          </v-card>
        </v-col>

        <v-col
          cols="10"
          offset="1"
          sm="8"
          offset-sm="2"
          offset-md="0"
          md="3">
          <v-card class="pa-10 text-center">
            <img
              src="/img/order/buy-message.png"
              height="85" />
            <div class="py-4 font-weight-bold _fs-24 _fs-lg-34 service-card-title">
              MESSAGE
            </div>
            <v-btn
              color="primary"
              width="100%"
              max-width="230px"
              rounded
              :to="{ name: 'OrderCreate', params: { productType: 'message' } }"
              @click="orderGTMEvent('existing_btn_msg_main', 'click_buy_btn_msg_main')"
            >
              สั่งซื้อ
            </v-btn>
          </v-card>
        </v-col>

        <v-col
          cols="10"
          offset="1"
          sm="8"
          offset-sm="2"
          offset-md="0"
          md="3">
          <v-card class="pa-10 text-center">
            <img
              src="/img/order/buy-premium-id.png"
              height="85" />
            <div class="py-4 font-weight-bold _fs-24 _fs-lg-34 service-card-title">
              Premium ID
            </div>
            <v-btn
              color="primary"
              width="100%"
              max-width="230px"
              rounded
              :to="{ name: 'OrderCreate', params: { productType: 'premiumId' } }"
              @click="orderGTMEvent('existing_btn_premium_main', 'click_buy_btn_premium_main')"
            >
              สั่งซื้อ
            </v-btn>
          </v-card>
        </v-col>

        <v-col
          cols="10"
          offset="1"
          sm="8"
          offset-sm="2"
          offset-md="0"
          md="3">
          <v-card class="pa-10 text-center">
            <img
              src="/img/order/oa-chat.png"
              height="85" />
            <div class="py-4 font-weight-bold _fs-24 _fs-lg-34 service-card-title">
              OA CHAT
            </div>
            <v-btn
              color="primary"
              width="100%"
              max-width="230px"
              rounded
              :to="{ name: 'OrderCreate', params: { productType: 'oaChat' } }"
              @click="orderGTMEvent('existing_btn_oa_main', 'click_buy_btn_oa_main')"
            >
              สั่งซื้อ
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <qr-line />
    <img
      v-if="isActiveLineOfficialAccountEmpty"
      class="d-none d-md-block _space-banner-no-line-oa _ps-fixed"
      src="/img/home/space-banner.jpg"
      loading="lazy"
      width="400"
      alt="Space Banner Image"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  isInRenewOrderDate,
  isInRenewPremiumIdDate,
  isInRenewOaChatDate,
  mapOrdersFilterFee,
  isUpdatedProfile
} from '@/utils/order.util'
import { isFalsy } from '../utils/isFalsy'

export default {
  name: 'HomePage',
  components: {
    OrderCardList: () => import('@/components/OrderCardList'),
    qrLine: () => import('@/components/QRLINE.vue'),
    modalNewFeature: () => import('@/components/ModalNewFeature.vue')
  },
  data() {
    return {
      showImage: true
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapState('Order', ['createOrderForm']),
    ...mapState('CustomerType', ['customerTypes']),
    lineUid() {
      return this.userProfile?.uid || null
    },
    ...mapState('Order', {
      orders: (state) => state.ordersByUserId
    }),
    ...mapGetters({
      activeBasicId: 'User/activeBasicId',
      activeLineOfficialAccount: 'User/activeLineOfficialAccount',
      isActiveLineOfficialAccountEmpty: 'User/isActiveLineOfficialAccountEmpty',
      MAXIMUM_PERIOD_PRE_ORDER: 'SystemConfig/GET_MAXIMUM_PERIOD_PRE_ORDER'
    }),
    mapOrders() {
      return mapOrdersFilterFee(this.orders)
    },
    hasNextPackagePlan() {
      return (
        this.activeLineOfficialAccount.packagePlan !== 'free'
        && this.activeLineOfficialAccount.nextPackagePlan !== 'free'
      )
    },
    hasPremiumIdNext() {
      return (
        !isFalsy(this.activeLineOfficialAccount.premiumIdNextExpiredAt)
        && !isFalsy(this.activeLineOfficialAccount.premiumIdNextStartedAt)
      )
    },
    hasNextOaChat() {
      return (
        !isFalsy(this.activeLineOfficialAccount.oaChatNextExpiredAt)
        && !isFalsy(this.activeLineOfficialAccount.oaChatNextStartedAt)
      )
    },
    isProfileUpdate() {
      return !isUpdatedProfile(this.activeLineOfficialAccount)
    }
  },
  mounted() {
    if (this.$utils.createDayjsDate().isBetween('2023-07-06', '2023-07-31', null, '[]')) {
      this.$swal({
        imageUrl:
          'https://sellsuki-web-storage-production.s3.ap-southeast-1.amazonaws.com/LINE_DIY_ea118e5cda.jpg',
        imageAlt: 'A tall image',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: 'my-swal'
        }
      })
    }
    if (this.$utils.createDayjsDate().isBetween('2020-12-23', '2021-01-04', null, '[]')) {
      this.$swal({
        title: 'ประกาศ',
        icon: 'warning',
        html: `
          แจ้งหยุดทำการเนื่องในเทศกาลปีใหม่</br>
          <span style="font-weight: bold; color: #01BB00;">ในวันที่ 31 ธันวาคม 2563 ถึงวันที่ 3 มกราคม 2564</span></br>
          <div style="font-weight: 700;">และจะเปิดทำการ วันที่ 4 มกราคม 2564</div></br>
          ทั้งนี้ลูกค้าสามารถทำรายการและแนบหลักฐานการชำระเงินได้ที่เว็บไซต์ไว้ได้ตามปกติ</br>
          เจ้าหน้าที่จะเร่งดำเนินการอนุมัติให้ในวันทำการครับ!</br>
          <div style="font-weight: 700;">หากต้องการติดต่อเจ้าหน้าที่ สามารถติดต่อได้ที่</div>
          <div><span style="font-weight: bold; color: #01BB00;">@linebysellsuki</span></div>
          ขออภัยในความไม่สะดวก</br>
          ท่านที่เดินทาง ขอให้เดินทางโดยสวัสดิภาพ</br> สวัสดีปีใหม่ลูกค้าที่น่ารักทุกท่านครับ! 🥰
        `,
        confirmButtonColor: '#01BB00',
        confirmButtonText: 'ตกลง'
      })
    }
  },
  methods: {
    isInRenewOrderDate,
    isInRenewPremiumIdDate,
    isInRenewOaChatDate,
    isFalsy,
    orderGTMEvent(label, event) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event,
        category: 'user_action',
        label,
        value: 1,
        userId: this.lineUid,
        premium_id: this.activeLineOfficialAccount.premiumId || null,
        basic_id: this.activeLineOfficialAccount.basicId || null,
        customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new'
      })
    },
    renewGTMEvent(label, event) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event,
        category: 'user_action',
        label,
        value: 1,
        userId: this.lineUid,
        premium_id: this.activeLineOfficialAccount.premiumId || null,
        basic_id: this.activeLineOfficialAccount.basicId || null,
        customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new'

      })
    }
  }
}
</script>

<style lang="scss" scoped>
._space-banner {
  bottom: 40px;
  right: -64px;
  opacity: 0.7;
}

._space-banner-no-line-oa {
  bottom: 0;
  right: 50px;
  opacity: 0.7;
}

._qr-line-image {
  right: 0;
  top: 0;
  z-index: 2;
}

.my-swal {
  background: transparent !important;
}

.service-card-title {
  min-height: 104px;
}
</style>
